module.exports = __webpack_public_path__ + "static/img/AA6503901.d7b6940b.jpg";